import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

const PerfumeIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='0.5'
    viewBox='0 0 24 24'
    width='auto'
    {...props}
  >
    <path
      stroke='none'
      d='M0 0h24v24H0z'
      fill='none'
    />
    <path d='M10 6v3' />
    <path d='M14 6v3' />
    <path d='M5 9m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z' />
    <path d='M12 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
    <path d='M9 3h6v3h-6z' />
  </Icon>
);

export default PerfumeIcon;
